/* template for use css with  StylizerProvider*/
export class CSST {
	css: string = `
		teaser .custom-range.item .symbol{
			color: rgb($color1$);
		}

		.range-ios-primary .range-bar-active, .range-ios-primary .range-tick-active{
			background-color: rgb($color1$);
		}

		teaser h1, teaser h2, teaser h3, teaser h4, teaser h5, teaser h6,
		teaser p.lead,
		teaser .box.results .result,
		teaser .box.results .bars-number,
		teaser .box.results .bars-number p{
			color: rgb($color1$);
		}

		.color-primary{
			color: rgb($color1$)!important;
		}
		.bg-primary{
			background-color: rgb($color1$)!important;
		}

		.button-clear-ios-primary,
		.button-clear-ios,
		.button-clear-ios:hover:not(.disable-hover){
			color: rgb($color1$);
		}

		.button-ios-primary{
			background-color: rgb($color1$);
		}

		teaser .custom-range.item .range .range-knob{
			background-color: rgb($color1$);
		}

		.range-ios .range-bar {
			background: rgba(0,0,0,.1);
		}

		teaser input.primary-border{
			border-color: rgb($color1$);
		}

		teaser .box,
		teaser .box-3 .item.blue{
			background-color: rgba($color5$);
		}

		teaser .document-container .box:before{
			border-color: transparent color: rgb($color1$); transparent transparent;
		}

		teaser .box.secondary{
			background-color: rgb($color8$);
		}

		teaser .box.results ul{
			color: rgb($color1$);
		}

		teaser .box-3 .item.blue [item-end]{
			color: rgb($color1$);
		}

		.spinner-ios-primary.spinner-ios line, .spinner-ios-primary.spinner-ios-small line, .spinner-ios-primary.spinner-crescent circle {
			stroke: rgb($color1$);
		}

		teaser .box.results .bars .progress-bar .bar.bar3,
		teaser .box.results .result .color.color3{
			background-color: rgb($color1$);
		}

		teaser .box.results .bars .progress-bar .bar.bar2,
		teaser .box.results .result .color.color1{
			background-color: rgb($color6$);
		}

		teaser .box.results .bars .progress-bar .bar.bar1,
		teaser .box.results .result .color.color2{
			background-color: rgb($color7$);
		}

	`;
}



// WEBPACK FOOTER //
// ./src/theme/CSST.ts